import Application from '../Application';
import ComputerSetup from './Computer';
import MonitorScreen from './MonitorScreen';
import AudioManager from '../Audio/AudioManager';
export default class World {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        // Wait for resources
        this.resources.on('ready', () => {
            // Setup
            this.computerSetup = new ComputerSetup();
            this.monitorScreen = new MonitorScreen();
            this.audioManager = new AudioManager();
        });
    }
    update() {
        if (this.monitorScreen)
            this.monitorScreen.update();
        if (this.audioManager)
            this.audioManager.update();
    }
}
